
/*
 * keygen
 * https://github.com/devmode/keygen
 *
 * Copyright (c) 2015 Sean M. Duncan
 * Licensed under the MIT license.
 */

(function() {
  var crypto, gen_for, large, medium, small;

  crypto = require('crypto');

  small = 11;

  medium = small * 2;

  large = medium * 2;

  gen_for = function(alpha) {
    var async, generate, it, sync;
    alpha = ((function() {
      var _i, _ref, _results;
      _results = [];
      for (it = _i = 0, _ref = 256 / alpha.length + 1; 0 <= _ref ? _i <= _ref : _i >= _ref; it = 0 <= _ref ? ++_i : --_i) {
        _results.push(alpha);
      }
      return _results;
    })()).join('').split('');
    generate = function(bytes) {
      var byte, key, _i, _len;
      key = '';
      for (_i = 0, _len = bytes.length; _i < _len; _i++) {
        byte = bytes[_i];
        key += alpha[byte];
      }
      return key;
    };
    sync = function(length) {
      var ex;
      try {
        return generate(crypto.randomBytes(length));
      } catch (_error) {
        ex = _error;
        return generate(crypto.pseudoRandomBytes(length));
      }
    };
    async = function(length, callback) {
      crypto.randomBytes(length, function(err, bytes) {
        if (err == null) {
          return callback(generate(bytes));
        }
        return crypto.pseudoRandomBytes(length, function(err, bytes) {
          return callback(generate(bytes));
        });
      });
    };
    return function(length, callback) {
      var _ref;
      if ((length != null ? length.constructor : void 0) === Function) {
        _ref = [callback, length], length = _ref[0], callback = _ref[1];
      }
      if (length == null) {
        length = medium;
      }
      if (callback != null) {
        return async(length, callback);
      } else {
        return sync(length);
      }
    };
  };

  module.exports = {
    gen_for: gen_for,
    hex: gen_for('0123456789abcdef'),
    url: gen_for('23456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ'),
    small: small,
    medium: medium,
    large: large
  };

}).call(this);
